<template>
  <el-dialog
      :model-value="props.visible"
      title="正常工资薪金所得 新增"
      width="1000"
      top="6vh"
      destroy-on-close
      :close-on-click-modal="false"
      @open="onOpen"
      @closed="closedModal"
  >
    <div v-loading="pageLoading">
      <div style="max-height: calc(80vh - 100px);overflow-y: auto;">
        <el-form :model="formData" ref="formRef" :rules="rules" :inline="true" label-width="100px">
          <div class="form-block">
            <div class="block-title">
              基本信息
            </div>

            <div class="block-content">
              <el-form-item label="工号" prop="employeesNo">
                <el-input
                    v-model="formData.employeesNo"
                    placeholder="请输入"
                    style="width: 180px"
                    maxlength="30"
                    clearable
                />
              </el-form-item>

              <el-form-item label="证照类型" prop="certificateType">
                <el-select
                    v-model="formData.certificateType"
                    disabled
                    style="width: 180px"
                    placeholder="请选择">
                  <el-option label="居民身份证" value="居民身份证"/>
                  <el-option label="中国护照" value="中国护照"/>
                </el-select>
              </el-form-item>

              <el-form-item label="所属期间起" prop="dateStart">
                <el-date-picker
                    type="date"
                    model-value="2026-01-01"
                    format="YYYY-MM-DD"
                    disabled
                    value-format="YYYY-MM-DD"
                    clearable
                    style="width: 180px"
                />
              </el-form-item>

              <el-form-item label="姓名" prop="name">
                <el-select
                    v-model="formData.name"
                    style="width: 180px"
                    placeholder="请选择"
                    @change="changePerson"
                >
                  <el-option
                      v-for="item in nameOptions"
                      :key="item.idNumber"
                      :label="item.name"
                      :value="item.idNumber"/>
                </el-select>
              </el-form-item>

              <el-form-item label="证照号码" prop="idNumber">
                <el-input
                    v-model="formData.idNumber"
                    placeholder="请输入"
                    style="width: 180px"
                    readonly
                    maxlength="30"
                    clearable
                />
              </el-form-item>

              <el-form-item label="所属期间止" prop="dateEnd">
                <el-date-picker
                    type="date"
                    model-value="2026-01-31"
                    format="YYYY-MM-DD"
                    disabled
                    value-format="YYYY-MM-DD"
                    clearable
                    style="width: 180px"
                />
              </el-form-item>

            </div>
          </div>

          <div class="form-block">
            <div class="block-title">
              本期收入及免税收入
            </div>

            <div class="block-content">

              <el-form-item label="适用公式" prop="suitMath"
                            style="align-items: center;"
              >
                <el-select
                    v-model="formData.suitMath"
                    clearable
                    style="width: 460px"
                    placeholder="请选择">
                  <el-option label="公式(1)不超过90天(非高管)" value="1"/>
                  <el-option label="公式(4)不超过90天(高管)" value="2"/>
                  <el-option label="公式(2)超过90天不满183天(非高管)" value="3"/>
                  <el-option label="公式(3)超过90天不满183天(高管)" value="4"/>
                  <el-option label="公式(1)税收协定居民不超过183天" value="5"/>
                  <el-option label="公式(3)满183天的年度连续不满六年" value="6"/>
                  <el-option label="公式(2)税收协定居民超过183天，但满183天的年度连续不满六年" value="7"/>
                  <el-option label="公式(5)满183天的年度连续满六年" value="8"/>
                  <el-option label="公式(5)有住所居民" value="9"/>
                </el-select>
                <div style="margin-left: 10px;line-height: 22px;">
                  <div style="color: blue;">居民身份证的无需选择</div>
                  <div>如不能确定适用公式，可点击<span style="color: blue;">帮助</span>进行系统引导</div>
                </div>
              </el-form-item>

              <el-form-item label="本期收入" prop="Answer_CurrentIncome">
                <el-input-number
                    v-model="formData.Answer_CurrentIncome"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
                <el-button
                    size="small"
                    style="margin-left: 10px;background-color: rgba(233,233,233,0.3);"
                    disabled
                >请录入明细
                </el-button>
              </el-form-item>

              <el-form-item label="本期免税收入" prop="Answer_CurrentExemptIncome">
                <el-input-number
                    v-model="formData.Answer_CurrentExemptIncome"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>
            </div>
          </div>

          <div class="form-block">
            <div class="block-title">
              本期专项扣除
            </div>

            <div class="block-content">

              <el-form-item label="基本养老保险费"
                            label-width="110px"
                            prop="Answer_BasicEndowmentInsurance">
                <el-input-number
                    v-model="formData.Answer_BasicEndowmentInsurance"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="基本医疗保险费"
                            label-width="110px"
                            prop="Answer_BasicMedicalInsurance">
                <el-input-number
                    v-model="formData.Answer_BasicMedicalInsurance"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="失业保险费" prop="Answer_UnemploymentInsurancePremium">
                <el-input-number
                    v-model="formData.Answer_UnemploymentInsurancePremium"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="住房公积金" label-width="110px" prop="Answer_HousingAccumulationFund">
                <el-input-number
                    v-model="formData.Answer_HousingAccumulationFund"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="小计"
                            class="orange-txt"
                            label-width="110px"
              >
                <div class="orange-wrap">
                  {{ Answer_SmallTotal1 }}
                </div>
              </el-form-item>
            </div>
          </div>

          <div class="form-block">
            <div class="block-title">
              累计扣除
            </div>

            <div class="block-content">

              <el-form-item label="子女教育" prop="Answer_CumulativeChildEducation">
                <el-input-number
                    v-model="formData.Answer_CumulativeChildEducation"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="住房贷款利息"
                            style="margin-left: 20px;"
                            prop="Answer_AccumulatedHousingLoanInterest">
                <el-input-number
                    v-model="formData.Answer_AccumulatedHousingLoanInterest"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item
                  label-width="140px"
                  label="住房租金" prop="Answer_AccumulatedHousingRent">
                <el-input-number
                    v-model="formData.Answer_AccumulatedHousingRent"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="赡养老人" prop="Answer_SupportTheElderlyCumulatively">
                <el-input-number
                    v-model="formData.Answer_SupportTheElderlyCumulatively"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="继续教育"
                            style="margin-left: 20px;"
                            prop="Answer_CumulativeContinuingEducation">
                <el-input-number
                    v-model="formData.Answer_CumulativeContinuingEducation"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item
                  label-width="140px"
                  label="3岁以下婴幼儿照护" prop="Answer_AccumulatedInfantChild">
                <el-input-number
                    v-model="formData.Answer_AccumulatedInfantChild"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="个人养老金" prop="anew1">
                <el-input-number
                    v-model="formData.anew1"
                    :precision="2"
                    class="num-input"
                    disabled
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="小计"
                            class="orange-txt"
                            style="margin-left: 20px;"
              >
                <div class="orange-wrap">
                  {{ Answer_SmallTotal2 }}
                </div>
              </el-form-item>
            </div>
          </div>

          <div class="form-block">
            <div class="block-title">
              本期其他扣除
            </div>

            <div class="block-content">

              <el-form-item
                  style="margin-left: -10px;"
                  label="企业(职业)年金"
                  label-width="110px"
                  prop="Answer_EnterpriseAnnuity">
                <el-input-number
                    v-model="formData.Answer_EnterpriseAnnuity"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="商业健康保险"
                            label-width="120px"
                            prop="Answer_CommercialHealthInsurance">
                <el-input-number
                    v-model="formData.Answer_CommercialHealthInsurance"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="税延养老保险"
                            label-width="120px"
                            style="margin-left: 20px;"
                            prop="Answer_TaxdeferredPensionInsurance">
                <el-input-number
                    v-model="formData.Answer_TaxdeferredPensionInsurance"
                    :precision="2"
                    disabled
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="其他"
                            label-width="100px"
                            prop="Answer_Other">
                <el-input-number
                    v-model="formData.Answer_Other"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="小计"
                            class="orange-txt"
                            style="margin-left: 20px;"
              >
                <div class="orange-wrap">
                  {{ Answer_SmallTotal3 }}
                </div>
              </el-form-item>
            </div>
          </div>

          <div class="form-block">
            <div class="block-title">
              本期其他
            </div>

            <div class="block-content">

              <el-form-item label="准予扣除的捐赠款"
                            label-width="130px"
                            style="margin-left: -20px;"
                            prop="Answer_PreDeductibleContributions">
                <el-input-number
                    v-model="formData.Answer_PreDeductibleContributions"
                    :precision="2"
                    style="width: 160px;"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="减免税额" prop="Answer_TaxRelief">
                <el-input-number
                    v-model="formData.Answer_TaxRelief"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="减除费用标准"
                            label-width="130px"
                            style="margin-left: 30px;"
              >
                <el-select
                    model-value="1"
                    disabled
                    style="width: 170px"
                    placeholder="请选择">
                  <el-option label="5000" value="1"/>
                </el-select>
              </el-form-item>

              <el-form-item label="已缴税额" prop="Answer_TheAmountTaxWithheld">
                <el-input-number
                    v-model="formData.Answer_TheAmountTaxWithheld"
                    :precision="2"
                    class="num-input"
                    disabled
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="备注" prop="remark">
                <el-input
                    v-model="formData.remark"
                    placeholder="请输入"
                    style="width: 730px"
                    maxlength="30"
                    clearable
                />
              </el-form-item>

              <div>温馨提示：本地区公积金可扣除上限为：3303.00元，年金可扣除上限为：1003.00元</div>
            </div>
          </div>

        </el-form>
      </div>

      <div class="my-footer">
        <el-button @click="emit('update:visible', false)">取消</el-button>
        <el-button type="primary" style="margin-right: 15px;" @click="onConfirm">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import {ElMessage} from "element-plus";
import {useTaxStore} from "@/store/modules/tax.js";
import Big from "big.js";

const taxStore = useTaxStore();
const {transferAdditionalList} = storeToRefs(taxStore);

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  currentRow: {
    type: Object,
    default: () => {
    }
  },
})

const pageLoading = ref(false)
const formData = ref({
  Answer_CurrentExemptIncome: 0.00,
  Answer_UnemploymentInsurancePremium: 0.00,
  Answer_HousingAccumulationFund: 0.00,
  Answer_CumulativeChildEducation: 0.00,
  Answer_AccumulatedHousingLoanInterest: 0.00,
  Answer_AccumulatedHousingRent: 0.00,
  Answer_SupportTheElderlyCumulatively: 0.00,
  Answer_CumulativeContinuingEducation: 0.00,
  Answer_AccumulatedInfantChild: 0.00,
  anew1: 0.00,
  Answer_TheAmountTaxWithheld: 0.00,
  certificateType: '居民身份证',
  Answer_BasicMedicalInsurance: 0.00,
  Answer_BasicEndowmentInsurance: 0.00,
  total_kc: 0.00,
  Answer_PreDeductibleContributions: 0.00,
  Answer_TaxdeferredPensionInsurance: 0.00,
  Answer_TaxRelief: 0.00,
  Answer_CommercialHealthInsurance: 0.00,
  Answer_Other: 0.00,
  Answer_EnterpriseAnnuity: 0.00,
})
const rules = reactive({
  Answer_CurrentIncome: [
    {required: true, message: '请输入', trigger: 'blur'},
  ],
  name: [
    {required: true, message: '请选择', trigger: 'change'},
  ],
})

const nameOptions = computed(() => {
  return transferAdditionalList.value.length && transferAdditionalList.value || []
})

function onOpen() {

}

function changePerson(val) {
  const person = nameOptions.value.find(f => f.idNumber == val) || {}
  formData.value.idNumber = person.idNumber
  formData.value.employeesNo = person.employeesNo
  formData.value.name = person.name
}

const formRef = ref()

const emit = defineEmits(['update:visible', 'refresh'])

async function onConfirm() {
  await formRef.value.validate(valid => {
    if (valid) {
      emit('update:visible', false)
      emit('confirm', formData.value)
    }
  })
}

const Answer_SmallTotal1 = computed(() => {
  return parseFloat(Big(formData.value.Answer_BasicEndowmentInsurance || 0)
      .plus(formData.value.Answer_BasicMedicalInsurance || 0)
      .plus(formData.value.Answer_UnemploymentInsurancePremium || 0)
      .plus(formData.value.Answer_HousingAccumulationFund || 0).toString()).toFixed(2)
})

const Answer_SmallTotal2 = computed(() => {
  return parseFloat(Big(formData.value.Answer_CumulativeChildEducation || 0)
      .plus(formData.value.Answer_AccumulatedHousingLoanInterest || 0)
      .plus(formData.value.Answer_AccumulatedHousingRent || 0)
      .plus(formData.value.Answer_CumulativeContinuingEducation || 0)
      .plus(formData.value.Answer_AccumulatedInfantChild || 0)
      .plus(formData.value.anew1 || 0)
      .plus(formData.value.Answer_SupportTheElderlyCumulatively || 0).toString()).toFixed(2)
})

const Answer_SmallTotal3 = computed(() => {
  return parseFloat(Big(formData.value.Answer_EnterpriseAnnuity || 0)
      .plus(formData.value.Answer_CommercialHealthInsurance || 0)
      .plus(formData.value.Answer_TaxdeferredPensionInsurance || 0)
      .plus(formData.value.Answer_Other || 0).toString()).toFixed(2)
})

function closedModal() {
  emit('update:visible', false)
  formData.value = {
    Answer_CurrentExemptIncome: 0.00,
    Answer_UnemploymentInsurancePremium: 0.00,
    Answer_HousingAccumulationFund: 0.00,
    Answer_CumulativeChildEducation: 0.00,
    Answer_AccumulatedHousingLoanInterest: 0.00,
    Answer_AccumulatedHousingRent: 0.00,
    Answer_SupportTheElderlyCumulatively: 0.00,
    Answer_CumulativeContinuingEducation: 0.00,
    Answer_AccumulatedInfantChild: 0.00,
    anew1: 0.00,
    Answer_TheAmountTaxWithheld: 0.00,
    certificateType: '居民身份证',
    Answer_BasicMedicalInsurance: 0.00,
    Answer_BasicEndowmentInsurance: 0.00,
    total_kc: 0.00,
    Answer_PreDeductibleContributions: 0.00,
    Answer_TaxdeferredPensionInsurance: 0.00,
    Answer_TaxRelief: 0.00,
    Answer_CommercialHealthInsurance: 0.00,
    Answer_Other: 0.00,
    Answer_EnterpriseAnnuity: 0.00,
  }
}
</script>

<style scoped lang="scss">
.form-block {
  .block-title {
    color: #000;
    font-size: 16px;
    border-left: 5px solid #4285F4;
    padding-left: 8px;
    line-height: 20px;
    margin-bottom: 15px;
  }

  .block-content {
    padding-left: 20px;

    .el-form-item {
      margin-right: 15px;
    }

    :deep(.num-input) {
      width: 170px;

      .el-input__inner {
        text-align: left;
      }
    }
  }

  .orange-txt {
    color: orange;

    :deep(.el-form-item__label) {
      color: inherit;
    }

    .orange-wrap {
      background-color: rgba(211, 211, 211, 0.4);
      width: 170px;
      box-sizing: border-box;
      padding: 0 10px;
    }
  }
}

.my-footer {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 30px;
}
</style>
